import { Component, Input } from '@angular/core';
import { EnumFasePLM } from '../../../product/plm/enums/fase-plm.enum';

interface IFaseCicloVida {
  fase: EnumFasePLM;
  label: string;
  icone: string;
  cor: string;
}

@Component({
  selector: 'sgt-ciclo-vida-timeline',
  templateUrl: './ciclo-vida-timeline.component.html',
  styleUrls: ['./ciclo-vida-timeline.component.scss'],
})
export class CicloVidaTimelineComponent {
  @Input() faseAtiva: EnumFasePLM = EnumFasePLM.Nascimento;
  @Input() ciclo: number | null = null;

  get textoCiclo(): string {
    return this.ciclo ? `Ciclo ${this.ciclo}` : '';
  }

  readonly fases: IFaseCicloVida[] = [
    { fase: EnumFasePLM.Nascimento, label: 'Nascimento', icone: 'fa-seedling', cor: 'nascimento' },
    { fase: EnumFasePLM.Crescimento, label: 'Crescimento', icone: 'fa-chart-line', cor: 'crescimento' },
    { fase: EnumFasePLM.Fortalecimento, label: 'Fortalecimento', icone: 'fa-dumbbell', cor: 'fortalecimento' },
    { fase: EnumFasePLM.Maturidade, label: 'Maturidade', icone: 'fa-tree', cor: 'maturidade' },
    { fase: EnumFasePLM.Encerramento, label: 'Encerramento', icone: 'fa-flag-checkered', cor: 'encerramento' },
  ];
}
